import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Changemass from "../images/ControlPanel.webp";
import Glace from "../images/House1.jpg";
import Glace2 from "../images/home2.jpg";
import SmartHomeVideo from "../videos/video.mp4";
import Trusted from "../images/TR.png";
import Tokyo from "../images/Tokyo.png";
import Blind from "../images/Blind.jpg";
import Personilized from "../images/Personilized.png";
import Secure from "../images/1746650.png";
import Energy from "../images/png-clipart-energy-conservation-computer-icons-energy-text-loan-thumbnail.png";
import Seam from "../images/6407238.png";
import SE from "../images/Gemini_Generated_Image_yq4dn1yq4dn1yq4d.png";
import TP from "../images/Gemini_Generated_Image_6v2h4p6v2h4p6v2h.png";
import Control from "../images/ntworkand .jpg";
import Damac from "../images/Damac.jpg";
import Alshafi from "../images/Alshafi.jpg";
import TCF from "../images/TCF.png";
import tuya from "../images/1200x600wa.png";
import flac from "../images/7921226.png";
import Telescope from "../images/Telescope.jpg";
import Yasser from "../images/Yasser.png";
import TimeZone from "../images/TimeZone.jpg";
import MapCanada from "../images/MapCanada.a3d6d1e91126c7771748.jpg";
import Hammer from "../images/Hammer.jpg";
import Lucera from "../images/Lucera.jpg";
import Leen from "../images/lenn.jpg";
import Dubai from "../images/futuristic-dubai-landscape.jpg";
import Amman from "../images/Abdali.jpg";
import Vibranum from "../images/vibranum.cfe097443564d53e819f.jpg";
import IRIS from "../images/Iris.jpg";
import Concept from "../images/Maa.png";
import Sth from "../images/Updated_SmartThings_Logo.png";
import Xi from "../images/xiaomi-new-2021-logo-png_seeklogo-400999.png";
import philips from "../images/Philips-Hue-Logo-digital-2017-Ralitsa-Tencheva.png";
import Ring from "../images/Ring_Inc.-Logo.wine_.png";
import AL from "../images/Alexa-logo.png";
import Google from "../images/Google-Home-Logo-1536x864.png";
import Mass from "../images/Mass Logo Reconstructed.png";
import agency from "../images/31agency.jpg";
import Alfurjan from "../images/Alfurjan.png";
import Zaaabeel from "../images/zaaabeel.jpg";
import PlanB from "../images/planB.jpg";
import Hills from "../images/Gemini_Generated_Image_n02nhgn02nhgn02n.png";
import Albeer from "../images/albeer.jpg";
import AS from "../images/works_with_apple_home-logo_brandlogos.net_ibfdn.png";
import Rahaf from "../images/Rahaf.eb3dfb1394912e02674a.jpg";
import Slider from "react-slick";
import { useLanguage } from "../pages/LanguageContext";
import {
  FaChevronDown,
  FaChevronLeft,
  FaChevronRight,
  FaInstagram,
  FaFacebookF,
  FaUsers,
  FaMapMarkerAlt,
} from "react-icons/fa";

const glanceTranslations = {
  en: {
    title: "at a Glance",
    tabs: ["About", "Vision", "Mission", "Values"],
    content: {
      About:
        "Mass Smart Solutions is redefining how the region lives — with cutting-edge automation, intelligent design, and unmatched reliability . Trusted across Jordan. Now building the future in Dubai...",
      Vision:
        "To lead the smart living revolution across the Middle East — by delivering intelligent, personalized, and future-ready automation experiences that redefine how people live, move, and feel at home...",
      Mission:
        "To design and deliver seamless smart home solutions that elevate everyday living — by combining advanced technology, tailored automation, and exceptional support for clients across Jordan, the UAE, and beyond...",
      Values:
        "At Mass Smart Solutions, we value innovation, personalization, and trust. We deliver reliable, tailored smart home experiences with integrity, customer-first support, and a deep commitment to both environmental responsibility and raising the standard of smart living across Jordan, Dubai, and the region...",
    },
  },
  ar: {
    title: "في لمحة",
    tabs: ["من نحن", "الرؤية", "الرسالة", "القيم"],
    content: {
      About:
        "شركة ماس للحلول الذكية هي شركة رائدة في أتمتة المنازل الذكية، تقدم حلولاً موثوقة ومصممة خصيصاً لأسلوب حياة كل عميل. موثوقون في الأردن، ونوسّع الآن نطاق خدماتنا إلى دبي لتقديم تجربة معيشة ذكية على أعلى مستوى في المنطقة",
      Vision:
        "أن نكون الروّاد في ثورة المعيشة الذكية في الشرق الأوسط — من خلال تقديم تجارب أتمتة ذكية، مخصصة، وجاهزة للمستقبل تعيد تعريف طريقة عيش الناس وتحركهم في منازلهم",
      Mission:
        "نصمم ونقدّم حلول منازل ذكية سلسة ترتقي بتجربة الحياة اليومية: عبر دمج التكنولوجيا المتقدمة و أنظمة الأتمتة المصممة حسب الطلب، والدعم المتميز لعملائنا في الأردن و الإمارات، و أبعد من ذلك",
      Values:
        "في ماس  للحلول الذكية، نؤمن بالابتكار، و التخصيص، والثقة. نقدم تجارب ذكية موثوقة ومصممة خصيصاً، مستندين على النزاهة، وأولوية دعم العملاء، والإلتزام التام بالمسؤولية البيئية، والارتقاء بأسلوب الحياة الذكية في الأردن، الإمارات، ومنطقة الشرق الأوسط",
    },
  },
};

const servicesTranslations = {
  en: {
    sectionTitle: "Our Main Services",
    services: [
      {
        title: "Smart Home Setup & Automation",
        description:
          "Design, installation, and tailored routines — covering lighting, climate, security, and access control",
        link: "/SmartHomeAutomationPage",
      },
      {
        title: " System Support & Maintenance",
        description:
          "Ongoing assistance, smart troubleshooting, and regular updates — to keep everything smooth, secure, and connected",
        link: "/services/home-security",
      },
      {
        title: " Network & Security Optimization",
        description:
          "Reliable Wi-Fi coverage, device integration, and network security planning for a stable smart environment",
        link: "/services/industrial-application",
      },
    ],
  },
  ar: {
    sectionTitle: "خدماتنا الرئيسية",
    services: [
      {
        title: "تركيب أنظمة المنزل الذكي",
        description:
          "تصميم وتنفيذ أنظمة ذكية متكاملة تشمل الإضاءة، التكييف، الأمن، والتحكم في الأبواب والستائر، مع برمجة روتينات مخصصة حسب أسلوب حياة كل عميل",
        link: "/SmartHomeAutomationPage",
      },
      {
        title: " تحسين الشبكة والأمان",
        description:
          "تخطيط احترافي لتغطية Wi-Fi، ربط الأجهزة الذكية بسلاسة، وتعزيز أمان الشبكة لضمان كفاءة التشغيل و استقرار النظام",
        link: "/services/home-security",
      },
      {
        title: "الدعم والصيانة الذكية",
        description:
          "مساعدة مستمرة، تشخيص الأعطال عن بُعد، زيارات ميدانية عند الحاجة، وتحديثات دورية للحفاظ على أداء النظام بأعلى كفاءة",
        link: "/services/industrial-application",
      },
    ],
  },
};

const proudTranslations = { en: "Proud To Work With", ar: "فخورون بالعمل مع" };

const whyMassTranslations = {
  en: [
    { title: "Trusted Partnerships", image: Trusted },
    { title: "Personalized Solutions", image: Personilized },
    { title: "Secure & Reliable", image: Secure },
    { title: "Energy Efficiency", image: Energy },
    { title: "Seamless Integration", image: Seam },
    { title: "Smart Living Experts", image: flac },
  ],
  ar: [
    { title: "شراكات موثوقة", image: Trusted },
    { title: "حلول مصممة خصيصاً", image: Personilized },
    { title: "أمان وموثوقية", image: Secure },
    { title: "كفاءة الطاقة", image: Energy },
    { title: "تكامل سلس", image: Seam },
    { title: "خبراء الحياة الذكية", image: flac },
  ],
};

const clientSectionTranslations = {
  en: {
    clientsCount: "+100 Clients Trust Us",
    pioneers: "Pioneers Who Trust Us",
    pioneersDesc:
      "We’re proud to be the smart home partner of choice for innovators, developers, and pioneers across the region. Each logo represents a collaboration built on trust, forward thinking, and a shared commitment to smarter living",
  },
  ar: {
    clientsCount: "+100 عميل يثق بنا",
    pioneers: "الروّاد الذين يثقون بنا",
    pioneersDesc:
      "نفخر بكوننا الشريك المفضل في حلول المنازل الذكية للروّاد والمطوّرين والمبتكرين في مختلف أنحاء المنطقة. كل شعار هنا يعبّر عن شراكة قائمة على الثقة والرؤية المستقبلية والسعي المشترك نحو أسلوب حياة أكثر ذكاء",
  },
};

const partnerLogos = [philips, Ring, Sth, Google, AS, AL, Xi, tuya, TP];

const SmartHomeIntro = () => {
  const { language } = useLanguage();
  const isAr = language === "ar";
  const currentServices = servicesTranslations[isAr ? "ar" : "en"];

  const [clients, setClients] = useState(0);
  const [insta, setInsta] = useState(0);
  const [fb, setFb] = useState(0);

  const navigate = useNavigate();
  const [heroStep, setHeroStep] = useState(0);
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    [Dubai, Amman].forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  useEffect(() => {
    document.body.style.margin = "0";
    document.body.style.padding = "0";
    document.body.style.overflowX = "hidden";

    const style = document.createElement("style");
    style.innerHTML = `
      @keyframes scrollLeft { 0%{transform:translateX(0)} 100%{transform:translateX(-50%)} }
      @keyframes bounce {
        0%,20%,50%,80%,100%{transform:translateY(0)}
        40%{transform:translateY(-10px)}
        60%{transform:translateY(-5px)}
      }
      @keyframes fadeInUp { from{opacity:0;transform:translateY(20px)} to{opacity:1;transform:translateY(0)} }
      @keyframes fadeInCard { from{opacity:0;transform:translateY(20px)} to{opacity:1;transform:translateY(0)} }
      @keyframes pulseGlow {
        0%{text-shadow:0 0 0px rgba(26,75,183,.4);transform:scale(1)}
        50%{text-shadow:0 0 18px rgba(26,75,183,.8);transform:scale(1.05)}
        100%{text-shadow:0 0 0px rgba(26,75,183,.4);transform:scale(1)}
      }
      .scroll-icon:hover { transform:scale(1.1); background-color:rgba(255,255,255,.25); }
      .hero, .hero video { animation:none!important; transform:none!important; }
      body{overflow-x:hidden!important;}

      /* Mobile-specific hero/video tweaks & logo marquee speed */
      @media (max-width:768px){
        .hero{ height:35vh !important; min-height:35vh !important; }
        .hero img, .hero video{ width:100%!important; height:100%!important; object-fit:contain!important; }
        .slider-container{width:100%;height:100%;position:relative;overflow:hidden}
        .slider-track{display:flex;width:300%;height:100%;transition:transform 1s ease-in-out}
      }
      @media (max-width:700px){
        .heroOverlay{ padding:0 .4rem !important; top:0;left:0;right:0;bottom:0;justify-content:center!important; }
        .heroSubline{ display:none!important; }
        .heroTitle{ font-size:1.3rem!important; font-weight:700!important; margin-bottom:1.1rem!important; text-shadow:none!important; color:#fff!important; line-height:1.2!important; }
        .cta-button{ font-size:1rem!important; padding:.7rem 1.2rem!important; min-width:150px; margin-top:.6rem!important; }

        .trusted-title{font-size:1.6rem!important;padding:0!important;margin:0!important;display:inline-block;position:relative}
        .trusted-title span{display:inline-block;padding:.4rem .6rem;position:relative}
        .trusted-title::before{
          content:"";position:absolute;width:18px;height:3px;top:0;right:0;
          background:linear-gradient(90deg,#1784e6,#1a4bb7)
        }
        .trusted-title::after{
          content:"";position:absolute;width:3px;height:18px;top:0;right:0;
          background:linear-gradient(180deg,#1784e6,#1a4bb7)
        }
        html[dir="rtl"] .trusted-title::before{left:0!important;right:auto!important}
        html[dir="rtl"] .trusted-title::after{left:0!important;right:auto!important}

        .logoScrollInner{ animation-duration:20s!important; min-width:1250%!important; gap:35px!important; }
      }

      /* CTA button fancy fill */
      .cta-button{
        position:relative; overflow:hidden; border:3px solid #1a4bb7; border-radius:30px;
        padding:.8rem 2rem; background-color:transparent; color:#fff; font-weight:600; font-size:1.1rem;
        cursor:pointer; transition:color .3s ease;
      }
      .cta-button::before{
        content:"";position:absolute;top:0;left:0;width:0;height:100%;background-color:#fff;z-index:0;transition:width .4s ease;
      }
      .cta-button:hover::before{ width:100%; }
      .cta-button:hover{ color:rgb(42, 91, 199); }
      .cta-button span{ position:relative; z-index:1; color:white; text-shadow:-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000; }

      /* Service card default and dark overrides */
      .service-card{
        background:#fff;color:#222;border-radius:12px;box-shadow:0 8px 20px rgba(0,0,0,.05);
        overflow:hidden;transition:transform .3s ease;width:100%;max-width:350px;
      }
      .dark .service-card{ background:#111; color:#fff; border:1px solid #fff; }
      .dark .service-card *{ color:inherit }

      /* Why Mass dark tweaks */
      .dark .why-mass-icon{ filter:brightness(0) invert(1) grayscale(.2)!important; transition:filter .3s; }
      .dark .why-mass-text{ color:#fff!important; transition:color .3s; }

      /* Title decoration block */
      .partial-border-title{
        display:inline-block;position:relative;padding:.6rem 1.5rem .6rem .6rem;font-weight:800;border-radius:0 17px 0 0;
        color:inherit;background:none;border:none;outline:none;text-align:left;background-clip:padding-box;font-size:2.2rem;
      }
      .partial-border-title::before,.partial-border-title::after{content:"";position:absolute;pointer-events:none;opacity:1}
      .partial-border-title::before{top:0;right:0;width:28px;height:5px;background:linear-gradient(90deg,#1784e6 0%,#1a4bb7 100%)}
      .partial-border-title::after{top:0;right:0;width:5px;height:25px;background:linear-gradient(180deg,#1784e6 0%,#1a4bb7 100%)}
      @media(max-width:700px){
        .partial-border-title{padding:.5rem .8rem .5rem .5rem;font-size:1.6rem!important}
        .partial-border-title::before{width:18px;height:3.5px}
        .partial-border-title::after{width:3.5px;height:18px}
      }

      /* Dots (react-slick) */
      .dark .slick-dots li button:before{color:#ffffff!important;opacity:.6}
      .dark .slick-dots li.slick-active button:before{color:#ffffff!important;opacity:1}
      .slick-dots li button:before{font-size:12px;transition:all .3s ease}

      /* Glance responsive background image injection */
      @media(max-width:768px){
        .glanceSection{flex-direction:column!important;background-image:none!important;padding:1rem!important;}
        .glanceSection::before{
          content:"";display:block;width:100%;height:220px;background-image:url(${Glace2});background-size:cover;background-position:center;border-radius:12px;margin-bottom:1rem;
        }
        .glanceSection div{ text-align:center!important; margin:0 auto!important; }
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      .heroSlides{position:absolute;inset:0;overflow:hidden}
      .heroSlide{
        position:absolute;inset:0;background-size:cover;background-position:center;background-repeat:no-repeat;
        opacity:0; transform:scale(1.04);
        transition: opacity 900ms cubic-bezier(.25,.8,.25,1), transform 6s ease;
        will-change:opacity,transform; backface-visibility:hidden;
      }
      .heroSlide.active{ opacity:1; transform:scale(1); }
      .heroTextFade{ animation:heroTextFadeIn .6s ease both; }
      @keyframes heroTextFadeIn{ from{opacity:0;transform:translateY(8px)} to{opacity:1;transform:translateY(0)} }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  useEffect(() => {
    const id = setInterval(() => setHeroStep((p) => (p === 0 ? 1 : 0)), 7000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    const animateValue = (setter, end, duration) => {
      let start = 0;
      const increment = end / (duration / 16);
      const step = () => {
        start += increment;
        if (start < end) {
          setter(Math.floor(start));
          requestAnimationFrame(step);
        } else {
          setter(end);
        }
      };
      step();
    };
    animateValue(setClients, 100, 1200);
    animateValue(setInsta, 33100, 1500);
    animateValue(setFb, 1800, 1700);
  }, []);

  useEffect(() => {
    const onScroll = () => setShowScrollTop(window.scrollY > 300);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const [activeTab, setActiveTab] = useState(
    glanceTranslations[isAr ? "ar" : "en"].tabs[0]
  );
  useEffect(() => {
    setActiveTab(glanceTranslations[isAr ? "ar" : "en"].tabs[0]);
  }, [isAr]);

  const carouselSettings = {
    infinite: true,
    centerMode: true,
    centerPadding: "60px",
    slidesToShow: 3,
    speed: 900,
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 1200,
    responsive: [
      { breakpoint: 768, settings: { slidesToShow: 1, centerPadding: "30px" } },
    ],
  };

  return (
    <main style={{ width: "100%", overflowX: "hidden" }}>
      <section
        className="hero"
        style={{
          ...styles.hero,
          minHeight: "92vh",
          padding: 0,
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
        }}
      >
        <div className="heroSlides">
          <div
            className={`heroSlide ${heroStep === 0 ? "active" : ""}`}
            style={{ backgroundImage: `url(${Dubai})` }}
          />
          <div
            className={`heroSlide ${heroStep === 1 ? "active" : ""}`}
            style={{ backgroundImage: `url(${Amman})` }}
          />
        </div>

        <div
          style={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(90deg,rgba(10,34,85,.55) 0%,rgba(19,51,120,.22) 100%)",
            zIndex: 1,
          }}
        />

        <div
          key={heroStep}
          className="heroOverlay heroTextFade"
          style={{
            ...styles.heroOverlay,
            zIndex: 2,
            width: "100%",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          {heroStep === 0 ? (
            <>
              <p className="heroSubline" style={styles.heroSubline}>
                {isAr
                  ? "نفتخر بتوسيع خبراتنا إلى قلب الابتكار"
                  : "Proudly extending our expertise to the heart of innovation"}
              </p>
              <h1 className="heroTitle" style={styles.heroTitle}>
                {isAr
                  ? "توسيع آفاقنا ماس الآن في دبي"
                  : "Expanding Horizons Mass is in Dubai"}
              </h1>
              <button
                className="cta-button"
                onClick={() => navigate("/contact")}
              >
                <span>{isAr ? "المزيد ←" : "Learn More →"}</span>
              </button>
            </>
          ) : (
            <>
              <p className="heroSubline" style={styles.heroSubline}>
                {isAr
                  ? "من الراحة إلى التحكم — نجعل المنازل تفكر."
                  : "From comfort to control — we make homes think."}
              </p>
              <h1 className="heroTitle" style={styles.heroTitle}>
                {isAr
                  ? "خبراء المنزل الذكي في الأردن"
                  : "Jordan’s Trusted Smart Home Experts"}
              </h1>
              <button
                className="cta-button"
                onClick={() => navigate("/contact")}
              >
                <span>{isAr ? "المزيد ←" : "Learn More →"}</span>
              </button>
            </>
          )}
        </div>

        <button
          className="fancy-arrow-btn"
          onClick={() => setHeroStep((prev) => (prev === 0 ? 1 : 0))}
          style={{ ...styles.arrowButton, left: "18px" }}
          aria-label="Previous slide"
        >
          <FaChevronLeft size={38} style={{ strokeWidth: 2.5 }} />
        </button>
        <button
          className="fancy-arrow-btn"
          onClick={() => setHeroStep((prev) => (prev === 1 ? 0 : 1))}
          style={{ ...styles.arrowButton, right: "18px" }}
          aria-label="Next slide"
        >
          <FaChevronRight size={38} style={{ strokeWidth: 2.5 }} />
        </button>

        {showScrollTop && (
          <div
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            style={styles.scrollTopBtn}
            className="scroll-icon"
          >
            <FaChevronDown size={20} style={{ transform: "rotate(180deg)" }} />
          </div>
        )}
      </section>

      <AmmanDubaiRoute isAr={isAr} />

      <section
        style={{
          width: "100%",
          minHeight: 480,
          display: "flex",
          flexDirection:
            window.innerWidth > 900 ? (isAr ? "row" : "row-reverse") : "column",
          alignItems: "center",
          justifyContent: "center",
          gap: window.innerWidth > 900 ? "8vw" : "2.5rem",
          padding: window.innerWidth > 900 ? "8rem 0" : "4rem 0 2.6rem 0",
          position: "relative",
          zIndex: 1,
          overflow: "visible",
        }}
      >
        {window.innerWidth > 900 ? (
          <>
            <div
              style={{
                flex: "0 0 640px",
                width: 650,
                aspectRatio: "16/9",
                borderRadius: 38,
                overflow: "hidden",
                background: "#193068",
                boxShadow: "0 8px 40px #19306814,0 1.5px 6px #2151a711",
                border: "4px solid #1a4bb7",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: 0,
                padding: 0,
                zIndex: 2,
                position: "relative",
              }}
            >
              <video
                src={SmartHomeVideo}
                autoPlay
                loop
                muted
                playsInline
                controls={false}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: 34,
                  background: "#1a2a4f",
                  boxShadow: "none",
                  border: "none",
                }}
              />
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: isAr ? "flex-end" : "flex-start",
                justifyContent: "center",
                direction: isAr ? "rtl" : "ltr",
                textAlign: isAr ? "right" : "left",
                zIndex: 3,
                margin: 0,
                maxWidth: 520,
                width: "100%",
                padding: "1.4rem 0",
                background: "none",
                position: "relative",
              }}
            >
              <h2
                style={{
                  fontWeight: 800,
                  fontSize: "2.7rem",
                  letterSpacing: isAr ? 0 : "-.008em",
                  textAlign: isAr ? "right" : "left",
                  margin: 0,
                  marginBottom: 10,
                  width: "100%",
                  padding: 0,
                  direction: isAr ? "rtl" : "ltr",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "0.6rem",
                }}
              >
                <span style={styles.gradient}>
                  {isAr
                    ? "شاهد سحر المنزل الذكي"
                    : "Experience Smart Home Magic"}
                </span>
              </h2>
              <div
                style={{
                  width: "100%",
                  height: 5,
                  background: "linear-gradient(90deg,#1a4bb7 70%,#2151a7 100%)",
                  borderRadius: 2,
                  opacity: 0.18,
                  marginBottom: 24,
                }}
              />
              <p
                style={{
                  width: "100%",
                  fontSize: "1.28rem",
                  fontWeight: 500,
                  marginBottom: 0,
                  padding: 0,
                  maxWidth: 500,
                }}
              >
                {isAr
                  ? "اكتشف كيف يمكن للأنظمة الذكية أن تحول تجربة منزلك وتفتح أبواب المستقبل في كل تفاصيل الحياة"
                  : "Discover how smart automation reimagines your home and opens the doors to a truly inspiring future."}
              </p>
            </div>
          </>
        ) : (
          <>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: isAr ? "flex-end" : "flex-start",
                justifyContent: "center",
                direction: isAr ? "rtl" : "ltr",
                textAlign: isAr ? "right" : "left",
                zIndex: 3,
                margin: 0,
                maxWidth: 520,
                width: "100%",
                padding: "1.2rem 1.2rem 1.6rem 1.2rem",
                background: "none",
                position: "relative",
              }}
            >
              <h2
                style={{
                  fontWeight: 800,
                  fontSize: "1.67rem",
                  letterSpacing: isAr ? 0 : "-.008em",
                  textAlign: isAr ? "right" : "left",
                  margin: 0,
                  marginBottom: 10,
                  width: "100%",
                  padding: 0,
                  direction: isAr ? "rtl" : "ltr",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "0.6rem",
                }}
              >
                <span style={styles.gradient}>
                  {isAr
                    ? "شاهد سحر المنزل الذكي"
                    : "Experience Smart Home Magic"}
                </span>
              </h2>
              <div
                style={{
                  width: "100%",
                  height: 5,
                  background: "linear-gradient(90deg,#1a4bb7 70%,#2151a7 100%)",
                  borderRadius: 2,
                  opacity: 0.18,
                  marginBottom: 24,
                }}
              />
              <p
                style={{
                  width: "100%",
                  fontSize: "1.18rem",
                  marginBottom: 0,
                  padding: 0,
                  maxWidth: 500,
                }}
              >
                {isAr
                  ? "اكتشف كيف يمكن للأنظمة الذكية أن تحول تجربة منزلك وتفتح أبواب المستقبل في كل تفاصيل الحياة"
                  : "Discover how smart automation reimagines your home and opens the doors to a truly inspiring future."}
              </p>
            </div>

            <div
              style={{
                width: "100%",
                maxWidth: 650,
                aspectRatio: "16/9",
                borderRadius: 38,
                overflow: "hidden",
                background: "#193068",
                boxShadow: "0 8px 40px #19306814,0 1.5px 6px #2151a711",
                border: "4px solid #1a4bb7",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: 0,
                padding: 0,
                zIndex: 2,
                position: "relative",
              }}
            >
              <video
                src={SmartHomeVideo}
                autoPlay
                loop
                muted
                playsInline
                controls={false}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: 34,
                  background: "#1a2a4f",
                  boxShadow: "none",
                  border: "none",
                }}
              />
            </div>
          </>
        )}
      </section>

      <section
        id="glanceSection"
        className="glanceSection"
        style={styles.glanceSection}
      >
        <div style={styles.glanceOverlay}>
          <h2
            style={{
              ...styles.glanceTitle,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: isAr ? "row-reverse" : "row",
              textAlign: "center",
              width: "100%",
              gap: "8px",
            }}
          >
            <span style={{ fontWeight: 700 }}>{isAr ? "لمحة عن " : ""}</span>
            <img
              src={Mass}
              loading="lazy"
              alt="Mass Logo"
              style={{
                height: "60px",
                verticalAlign: "middle",
                margin: isAr ? "0 0 0 8px" : "0 8px 0 0",
              }}
            />
            <span style={{ fontWeight: 700 }}>{isAr ? "" : "at a Glance"}</span>
          </h2>

          <div className="tabNav" style={styles.tabNav}>
            {glanceTranslations[isAr ? "ar" : "en"].tabs.map((tab) => (
              <span
                key={tab}
                onClick={() => setActiveTab(tab)}
                style={{
                  ...styles.tabItem,
                  ...styles.wordStroke,
                  ...(activeTab === tab ? styles.activeTab : {}),
                }}
              >
                {tab}
              </span>
            ))}
          </div>

          <p style={styles.glanceDescription}>
            {
              glanceTranslations[isAr ? "ar" : "en"].content[
                glanceTranslations[isAr ? "ar" : "en"].tabs.indexOf(
                  activeTab
                ) !== -1
                  ? Object.keys(glanceTranslations[isAr ? "ar" : "en"].content)[
                      glanceTranslations[isAr ? "ar" : "en"].tabs.indexOf(
                        activeTab
                      )
                    ]
                  : activeTab
              ]
            }
          </p>
        </div>
      </section>

      <section
        style={{
          padding: "5rem 2rem",
          textAlign: "center",
          direction: isAr ? "rtl" : "ltr",
          fontFamily: isAr
            ? "'Cairo','Tajawal',sans-serif"
            : "Inter, sans-serif",
        }}
      >
        <h2
          className="partial-border-title"
          style={{
            fontSize: isAr
              ? "clamp(2.2rem,5vw,3.2rem)"
              : "clamp(2.2rem,6vw,3.2rem)",
            fontWeight: 900,
            marginBottom: "2.3rem",
            letterSpacing: isAr ? 0 : "0.02em",
            lineHeight: 1.2,
            textAlign: "center",
          }}
        >
          <span style={styles.gradient}>{currentServices.sectionTitle}</span>
        </h2>

        <p
          style={{
            maxWidth: "750px",
            margin: "0 auto 3rem",
            fontSize: "1.15rem",
            lineHeight: 1.8,
            fontWeight: 400,
          }}
        >
          {isAr
            ? "نقدم حلولاً ذكية متطورة تلائم احتياجاتك اليومية بدقة وأناقة. من الأمان والتحكم إلى الكفاءة والطاقة — خدماتنا مصممة لتجعل حياتك أكثر راحة واتصالاً"
            : "At Mass Smart Solutions, we offer a wide range of smart-home services. Here are our core areas of expertise:"}
        </p>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: "2rem",
            justifyItems: "center",
          }}
        >
          {currentServices.services.map((service, index) => (
            <div
              key={index}
              className="service-card"
              onMouseEnter={(e) =>
                (e.currentTarget.style.transform = "translateY(-6px)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = "translateY(0)")
              }
            >
              <img
                src={index === 0 ? Changemass : index === 1 ? SE : Control}
                loading="lazy"
                alt={service.title}
                style={{ width: "100%", height: "200px", objectFit: "cover" }}
              />
              <div style={{ padding: "1.4rem" }}>
                <h3
                  style={{
                    fontSize: "1.2rem",
                    fontWeight: 700,
                    marginBottom: "0.6rem",
                    direction: isAr ? "rtl" : "ltr",
                  }}
                >
                  {service.title}
                </h3>
                <p
                  style={{
                    fontSize: "0.95rem",
                    marginBottom: "1rem",
                    direction: isAr ? "rtl" : "ltr",
                  }}
                >
                  {service.description}
                </p>
                <a
                  href={`${service.link}?lang=${language}`}
                  style={{
                    fontWeight: 600,
                    textDecoration: "none",
                    fontSize: "0.95rem",
                    display: "inline-block",
                    direction: isAr ? "rtl" : "ltr",
                  }}
                >
                  {isAr ? "المزيد →" : "Learn More →"}
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section
        style={{
          ...styles.productsCarousel,
          direction: isAr ? "rtl" : "ltr",
          fontFamily: isAr ? "'Cairo','Tajawal',Arial,sans-serif" : undefined,
        }}
      >
        <h2
          className="partial-border-title"
          style={{
            fontSize: isAr
              ? "clamp(2.2rem,5vw,3.2rem)"
              : "clamp(2.2rem,6vw,3.2rem)",
            fontWeight: 900,
            marginBottom: "2.3rem",
            letterSpacing: isAr ? 0 : "0.02em",
            lineHeight: 1.2,
          }}
        >
          <span style={styles.gradient}>
            {isAr ? "لماذا ماس؟" : "Why Mass?"}
          </span>
        </h2>

        <Slider {...carouselSettings}>
          {whyMassTranslations[isAr ? "ar" : "en"].map((item, index) => (
            <div key={index} style={styles.productCard}>
              <img
                src={item.image}
                loading="lazy"
                alt={item.title}
                className="why-mass-icon"
                style={styles.productImage}
              />
              <p
                className="why-mass-text"
                style={{
                  ...styles.productTitle,
                  fontFamily: isAr
                    ? "'Cairo','Tajawal',Arial,sans-serif"
                    : undefined,
                  direction: isAr ? "rtl" : "ltr",
                  textAlign: "center",
                }}
              >
                {item.title}
              </p>
            </div>
          ))}
        </Slider>
      </section>

      <section
        style={{
          ...styles.clientsSection,
          direction: isAr ? "rtl" : "ltr",
          fontFamily: isAr
            ? "'Cairo','Tajawal',Tahoma,Arial,sans-serif"
            : "Poppins, sans-serif",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "2.2rem",
            marginBottom: "1.3rem",
            flexWrap: "wrap",
            zIndex: 1,
          }}
        >
          {[
            { name: isAr ? "دبي" : "Dubai", color: "#1a4bb7" },
            { name: isAr ? "عمان" : "Amman", color: "#1a4bb7" },
          ].map((city) => (
            <div
              key={city.name}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                minWidth: "90px",
                margin: "0 0.6rem",
              }}
            >
              <span
                style={{
                  display: "inline-block",
                  marginBottom: "10px",
                  animation: "floatUpDown 2s ease-in-out infinite",
                }}
              >
                <FaMapMarkerAlt
                  size={32}
                  color={city.color}
                  style={{ filter: "drop-shadow(0 2px 10px #2297e644)" }}
                />
              </span>
              <span
                style={{
                  display: "inline-block",
                  background: `linear-gradient(90deg, #1784e6 0%, #1a4bb7 100%)`,
                  color: "#fff",
                  padding: "0.65rem 1.7rem",
                  borderRadius: "30px",
                  fontWeight: 700,
                  fontSize: isAr ? "1.07rem" : "1.12rem",
                  letterSpacing: "0.6px",
                  boxShadow: "0 2px 16px 0 rgba(23,132,230,0.09)",
                  fontFamily: isAr
                    ? "'Cairo', sans-serif"
                    : "'Poppins', sans-serif",
                  border: "none",
                  position: "relative",
                  transition:
                    "transform 0.23s cubic-bezier(.48,1.7,.36,.83), box-shadow 0.2s",
                  cursor: "default",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform =
                    "translateY(-4px) scale(1.06)";
                  e.currentTarget.style.boxShadow = "0 8px 20px 0 #1784e63b";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = "";
                  e.currentTarget.style.boxShadow =
                    "0 2px 16px 0 rgba(23,132,230,0.09)";
                }}
              >
                {city.name}
              </span>
            </div>
          ))}
        </div>

        <h2 className="partial-border-title">
          <span style={styles.gradient}>
            {clientSectionTranslations[isAr ? "ar" : "en"].pioneers}
          </span>
        </h2>
        <p style={styles.clientsSubtitle}>
          {clientSectionTranslations[isAr ? "ar" : "en"].pioneersDesc}
        </p>

        <div style={styles.clientsGrid}>
          {[
            Damac,
            Alshafi,
            TCF,
            Telescope,
            Yasser,
            TimeZone,
            MapCanada,
            Hammer,
            Lucera,
            Leen,
            Vibranum,
            IRIS,
            Concept,
            agency,
            Rahaf,
            Albeer,
            Alfurjan,
            Hills,
            PlanB,
            Zaaabeel,
            Blind,
            Tokyo,
          ].map((logo, idx) => (
            <div
              key={idx}
              style={styles.clientCard}
              onMouseEnter={(e) =>
                (e.currentTarget.style.transform = "scale(1.05)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.transform = "scale(1)")
              }
            >
              <img
                src={logo}
                loading="lazy"
                alt={`Client ${idx + 1}`}
                style={styles.clientLogo}
              />
            </div>
          ))}
        </div>
      </section>

      <section
        style={{
          padding: "3rem 2rem",
          textAlign: "center",
          fontFamily: isAr ? "'Cairo', sans-serif" : "'Poppins', sans-serif",
          direction: isAr ? "rtl" : "ltr",
        }}
      >
        <h2
          className="partial-border-title"
          style={{
            fontSize: isAr
              ? "clamp(2.4rem,5vw,3.2rem)"
              : "clamp(2.4rem,6vw,3.2rem)",
            fontWeight: 800,
            marginBottom: "2.3rem",
            lineHeight: 1.3,
            textAlign: "center",
          }}
        >
          <span style={styles.gradient}>
            {isAr
              ? "موضع ثقة أكثر من ١٠٠ عميل في المنطقة"
              : "Trusted by 100+ Clients Across the Region"}
          </span>
        </h2>

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: "3rem",
            marginTop: "2rem",
          }}
        >
          <div
            style={{
              textAlign: "center",
              animation: "fadeInUp 1s ease-in-out",
            }}
          >
            <FaUsers
              size={48}
              style={{ color: "#1a4bb7", marginBottom: "1rem" }}
            />
            <h3
              style={{
                fontSize: "2.6rem",
                fontWeight: 800,
                color: "#1a4bb7",
                animation: "pulseGlow 2s infinite ease-in-out",
              }}
            >
              +{clients}
            </h3>
            <p style={{ fontSize: "1.1rem", color: "#6b7280" }}>
              {isAr ? "عميل موثوق" : "Clients"}
            </p>
          </div>

          <div
            style={{
              textAlign: "center",
              animation: "fadeInUp 1.2s ease-in-out",
            }}
          >
            <FaInstagram
              size={48}
              style={{ color: "#C13584", marginBottom: "1rem" }}
            />
            <h3
              style={{
                fontSize: "2.6rem",
                fontWeight: 800,
                color: "#C13584",
                animation: "pulseGlow 2s infinite ease-in-out",
              }}
            >
              {insta.toLocaleString()}
            </h3>
            <p style={{ fontSize: "1.1rem", color: "#6b7280" }}>
              Instagram {isAr ? "متابع" : "Followers"}
            </p>
          </div>

          <div
            style={{
              textAlign: "center",
              animation: "fadeInUp 1.4s ease-in-out",
            }}
          >
            <FaFacebookF
              size={48}
              style={{ color: "#1877f2", marginBottom: "1rem" }}
            />
            <h3
              style={{
                fontSize: "2.6rem",
                fontWeight: 800,
                color: "#1877f2",
                animation: "pulseGlow 2s infinite ease-in-out",
              }}
            >
              {fb.toLocaleString()}
            </h3>
            <p style={{ fontSize: "1.1rem", color: "#6b7280" }}>
              Facebook {isAr ? "متابع" : "Followers"}
            </p>
          </div>
        </div>
      </section>

      <section style={styles.logoScrollSection}>
        <h2
          className="partial-border-title"
          style={{
            fontSize: "clamp(1.3rem, 7vw, 2.7rem)",
            fontWeight: 900,
            marginBottom: "2.3rem",
            letterSpacing: isAr ? 0 : "0.02em",
            lineHeight: 1.2,
            direction: isAr ? "rtl" : "ltr",
            fontFamily: isAr ? "'Cairo','Tajawal',Arial,sans-serif" : undefined,
          }}
        >
          <span style={styles.gradient}>
            {proudTranslations[isAr ? "ar" : "en"]}
          </span>
        </h2>

        <div style={styles.logoScrollWrapper}>
          <div className="logoScrollInner" style={styles.logoScrollInner}>
            {[...partnerLogos, ...partnerLogos].map((logo, index) => (
              <img
                key={index}
                src={logo}
                loading="lazy"
                alt={`Partner Logo ${index + 1}`}
                style={styles.partnerLogo}
              />
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

const styles = {
  hero: {
    position: "relative",
    width: "100%",
    minHeight: "88vh",
    height: "80vh",
    overflow: "hidden",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: 0,
    padding: 0,
  },
  heroOverlay: {
    position: "relative",
    zIndex: 2,
    textAlign: "center",
    color: "#fff",
    padding: "0 2rem",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  heroTitle: {
    fontSize: "clamp(2rem, 5vw, 4rem)",
    fontWeight: "bold",
    marginBottom: "1rem",
    color: "#fff",
    textShadow:
      "-1px -1px 0 #000, 1px -1px 0 #000, -1px  1px 0 #000, 1px  1px 0 #000",
  },
  heroSubline: {
    fontSize: "clamp(1rem, 3vw, 1.5rem)",
    marginBottom: "2rem",
    color: "#fff",
    textShadow:
      "-1px -1px 0 #000, 1px -1px 0 #000, -1px  1px 0 #000, 1px  1px 0 #000",
  },
  arrowButton: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    background: "none",
    color: "#1769c6",
    border: "none",
    padding: "0.1rem 0.7rem",
    borderRadius: "50%",
    fontSize: "2.7rem",
    fontWeight: 900,
    zIndex: 3,
    cursor: "pointer",
    outline: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "color 0.17s, transform 0.12s",
    opacity: 0.93,
    userSelect: "none",
  },
  glanceSection: {
    position: "relative",
    backgroundImage: `url(${Glace})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    width: "100%",
    padding: "2rem 1rem",
    marginTop: "60px",
    color: "#fff",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    minHeight: "400px",
  },
  glanceOverlay: {
    width: "100%",
    maxWidth: "600px",
    padding: "1.5rem 2rem",
    textAlign: "center",
    backgroundColor: "rgba(70, 62, 62, 0.5)",
    borderRadius: "16px",
    animation: "fadeInUp 1.5s ease-in-out",
    boxShadow: "0 8px 20px rgba(110, 99, 99, 0.4)",
    marginLeft: "2rem",
    marginRight: "auto",
  },
  glanceTitle: {
    fontSize: "clamp(1.5rem, 5vw, 2.5rem)",
    marginBottom: "1.5rem",
    color: "white",
    textAlign: "center",
  },
  tabNav: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: "1.5rem",
    marginBottom: "1.5rem",
    borderBottom: "2px solid rgb(46, 126, 200)",
    paddingBottom: "0.5rem",
  },
  tabItem: {
    fontSize: "1rem",
    paddingBottom: "0.5rem",
    cursor: "pointer",
    color: "white",
    borderBottom: "3px solid transparent",
    transition: "all 0.3s ease",
  },
  activeTab: {
    fontSize: "1.2rem",
    color: "white",
    fontWeight: "700",
    borderBottom: "3px solid #1a4bb7",
  },
  glanceDescription: {
    fontSize: "clamp(1rem, 2.5vw, 1.1rem)",
    lineHeight: "1.6",
    color: "white",
    animation: "fadeInUp 1s ease-in-out",
  },

  productsCarousel: { padding: "4rem 2rem", textAlign: "center" },
  productCard: {
    borderRadius: "16px",
    padding: "2rem 1rem",
    textAlign: "center",
    margin: "0 auto",
    transition: "transform 0.3s ease",
    boxShadow: "0 8px 24px rgba(0,0,0,0.05)",
  },
  productImage: { width: "100px", height: "100px", marginBottom: "1rem" },
  productTitle: { fontSize: "1.1rem", fontWeight: "600", color: "#333" },

  clientsSection: { textAlign: "center", padding: "5rem 1rem" },
  clientsSubtitle: {
    fontSize: "1rem",
    marginBottom: "2.5rem",
    lineHeight: "1.6",
    maxWidth: "700px",
    marginLeft: "auto",
    marginRight: "auto",
  },
  clientsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
    gap: "1.5rem",
    justifyContent: "center",
    maxWidth: "900px",
    margin: "0 auto",
    alignItems: "center",
  },
  clientCard: {
    borderRadius: "12px",
    padding: "1.5rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    height: "160px",
    animation: "fadeInCard 0.8s ease both",
  },
  clientLogo: {
    maxHeight: "130px",
    maxWidth: "130%",
    objectFit: "cover",
    filter: "grayscale(0%)",
    transition: "transform 0.3s ease, filter 0.3s ease",
  },

  logoScrollSection: { padding: "3rem 1rem", textAlign: "center" },
  logoScrollWrapper: { overflow: "hidden" },
  logoScrollInner: {
    display: "flex",
    gap: "60px",
    animation: "scrollLeft 18s linear infinite",
    minWidth: "360%",
    flexWrap: "nowrap",
  },
  partnerLogo: {
    height: "120px",
    maxWidth: "200px",
    padding: "0px",
    backgroundColor: "transparent",
    borderRadius: "0",
    objectFit: "contain",
    boxShadow: "none",
    flexShrink: 0,
    transition: "transform 0.3s, filter 0.3s",
  },

  gradient: {
    background: "linear-gradient(to right, #1784e6 0%, #1a4bb7)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },
  wordStroke: { color: "#ffffff", display: "inline-block", fontWeight: "500" },
  scrollTopBtn: {
    position: "fixed",
    bottom: "25px",
    left: "25px",
    width: "48px",
    height: "48px",
    borderRadius: "50%",
    backgroundColor: "rgba(0,0,0,0.5)",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    zIndex: 999,
    boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
    transition: "opacity 0.3s ease",
  },
};

function useDarkMode() {
  const [isDark, setIsDark] = useState(() => {
    if (typeof document === "undefined") return false;
    const htmlHasDark = document.documentElement.classList.contains("dark");
    const prefersDark =
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches;
    return htmlHasDark || prefersDark;
  });

  useEffect(() => {
    if (typeof document === "undefined") return;
    const html = document.documentElement;

    const obs = new MutationObserver(() =>
      setIsDark(html.classList.contains("dark"))
    );
    obs.observe(html, { attributes: true, attributeFilter: ["class"] });

    let mql;
    const handler = (e) =>
      setIsDark(html.classList.contains("dark") || e.matches);
    if (window.matchMedia) {
      mql = window.matchMedia("(prefers-color-scheme: dark)");
      try {
        mql.addEventListener("change", handler);
      } catch {
        mql.addListener(handler);
      }
    }
    return () => {
      obs.disconnect();
      if (mql) {
        try {
          mql.removeEventListener("change", handler);
        } catch {
          mql.removeListener(handler);
        }
      }
    };
  }, []);

  return isDark;
}

const AmmanDubaiRoute = ({ isAr = false }) => {
  const isDark = useDarkMode();

  const planeColor = "#1784E6";

  const labels = {
    title: isAr ? "من عمّان إلى دبي" : "From Amman to Dubai",
    subtitle: isAr
      ? "نخدمكم بين الأردن والإمارات — رحلة واحدة، خدمة موحّدة"
      : "Serving you across Jordan & the UAE — one journey, one seamless service",
    amman: isAr ? "عمّان" : "Amman",
    dubai: isAr ? "دبي" : "Dubai",
  };

  return (
    <section
      style={{
        padding: "4rem 1rem 0rem",
        display: "grid",
        placeItems: "center",
        textAlign: "center",
      }}
    >
      <style>{`
        .route-subtitle {
          color: #FFFFFF !important;
          opacity: 1 !important;
          text-shadow: 0 1px 2px #000000;
        }
        html.light .route-subtitle {
          color: #333333 !important;
          text-shadow: none !important;
        }
      `}</style>

      <h2
        style={{
          fontSize: "clamp(2rem, 5vw, 3rem)",
          fontWeight: 900,
          marginBottom: "0.75rem",
        }}
      >
        <span
          style={{
            background: "linear-gradient(to right, #1784E6 0%, #1A4BB7 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
          }}
        >
          {labels.title}
        </span>
      </h2>

      <p
        className="route-subtitle"
        style={{ maxWidth: 720, fontSize: "1.25rem", marginBottom: "0.6rem" }}
      >
        {labels.subtitle}
      </p>

      <div
        style={{
          width: "min(100%, 1000px)",
          aspectRatio: "21/9",
          borderRadius: 24,
          overflow: "hidden",
          position: "relative",
        }}
      >
        <svg
          viewBox="0 0 1000 430"
          preserveAspectRatio="xMidYMid meet"
          style={{ width: "100%", height: "100%" }}
        >
          <defs>
            <path id="routePath" d="M 250 220 Q 400 100, 500 220 T 750 220" />
          </defs>

          <use
            href="#routePath"
            style={{
              fill: "none",
              stroke: "#1784E6",
              strokeWidth: 4,
              strokeDasharray: "12 9",
              strokeLinecap: "round",
            }}
          />

          <g fontSize="70" fill={planeColor}>
            <text>
              ✈
              <animateMotion
                dur="6s"
                repeatCount="indefinite"
                rotate="auto"
                keyTimes="0;0.05;0.95;1"
                keySplines="0.4 0 0.2 1; 0.4 0 0.2 1; 0.4 0 0.2 1"
                calcMode="spline"
              >
                <mpath href="#routePath" />
              </animateMotion>
            </text>
          </g>

          <g transform="translate(250,220)">
            <path
              d="M0,-22 C12,-22 22,-12 22,0 C22,15 8,25 0,38 C-8,25 -22,15 -22,0 C-22,-12 -12,-22 0,-22 Z"
              style={{ fill: "#1784E6", stroke: "#FFFFFF", strokeWidth: 2 }}
            />
            <circle cx="0" cy="-8" r="6" style={{ fill: "#FFFFFF" }} />
            <text
              x="0"
              y="75"
              textAnchor="middle"
              fontSize="32"
              fontWeight="800"
              style={{
                fill: "none",
                stroke: "#000000",
                strokeWidth: 3,
              }}
            >
              {labels.amman}
            </text>
            <text
              x="0"
              y="75"
              textAnchor="middle"
              fontSize="32"
              fontWeight="800"
              style={{
                fill: isDark ? "#FFFFFF" : "#ffffffff",
              }}
            >
              {labels.amman}
            </text>
          </g>

          <g transform="translate(750,220)">
            <path
              d="M0,-22 C12,-22 22,-12 22,0 C22,15 8,25 0,38 C-8,25 -22,15 -22,0 C-22,-12 -12,-22 0,-22 Z"
              style={{ fill: "#1784E6", stroke: "#FFFFFF", strokeWidth: 2 }}
            />
            <circle cx="0" cy="-8" r="6" style={{ fill: "#FFFFFF" }} />
            <text
              x="0"
              y="75"
              textAnchor="middle"
              fontSize="32"
              fontWeight="800"
              style={{
                fill: "none",
                stroke: "#000000",
                strokeWidth: 3,
              }}
            >
              {labels.dubai}
            </text>
            <text
              x="0"
              y="75"
              textAnchor="middle"
              fontSize="32"
              fontWeight="800"
              style={{
                fill: isDark ? "#FFFFFF" : "#ffffffff",
              }}
            >
              {labels.dubai}
            </text>
          </g>
        </svg>
      </div>
    </section>
  );
};

export default SmartHomeIntro;
